<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<div
  class="min-h-screen flex flex-col bg-age-cream text-age-green font-segoe pb-32"
>
  <header class="flex flex-col items-center pt-10 pb-6">
    <img src="logo.png" alt="AGE Logo" class="w-32 h-auto mb-4" />
    <h1 class="font-bebas text-4xl tracking-wider">INSCRIPTION GROUPE</h1>
    <p class="text-sm text-gray-500 font-semibold">
      Remplissez le formulaire ci-dessous
    </p>
  </header>

  <form
    [formGroup]="groupForm"
    (submit)="onSubmit()"
    class="flex-1 flex flex-col items-center px-4 space-y-8"
  >
    <section formGroupName="company" class="form-box">
      <div class="flex items-center justify-center relative mb-12">
        <button
          type="button"
          (click)="backPage()"
          class="absolute left-0 text-age-green hover:!text-age-gold transition-colors cursor-pointer"
        >
          <lib-arrow-left size="l"></lib-arrow-left>
        </button>

        <h1 class="font-bebas text-4xl text-age-green uppercase text-center">
          INFORMATIONS DE L'ENTREPRISE
        </h1>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <lib-form-field
          label="Nom de l'entreprise"
          placeholder="Nom"
          [control]="getCompanyControl('name')"
        />
        <lib-form-field
          label="ICE"
          placeholder="ICE"
          [control]="getCompanyControl('ice')"
        />
        <lib-form-field
          label="Adresse postale"
          placeholder="Adresse postale"
          [control]="getCompanyControl('address')"
        />
        <lib-form-field
          label="Ville"
          placeholder="Ville"
          [control]="getCompanyControl('city')"
        />

        <lib-form-field
          class="flex flex-col gap-1 md:col-span-2 max-w-[50%] mx-auto w-full"
          label="Pays"
          placeholder="Pays"
          [control]="getCompanyControl('country')"
        />
      </div>
    </section>
    <section formGroupName="representative" class="form-box">
      <div class="flex items-center justify-center relative mb-12">
        <h1 class="font-bebas text-4xl text-age-green uppercase text-center">
          INFORMATIONS DU REPRÉSENTANT
        </h1>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <lib-form-field
          label="Nom complet"
          placeholder="Nom complet"
          [control]="getRepresentativeControl('fullName')"
        />
        <lib-form-field
          label="Role"
          placeholder="Role"
          [control]="getRepresentativeControl('role')"
        />
        <lib-form-field
          label="Numéro de téléphone"
          placeholder="Numéro de téléphone"
          type="tel"
          [control]="getRepresentativeControl('phoneNumber')"
        />
        <lib-form-field
          label="Email"
          placeholder="Email"
          type="email"
          [control]="getRepresentativeControl('email')"
        />
        <lib-form-textarea
          label="Remarques ou demandes particulières (facultatif)"
          class="col-span-1 md:col-span-2"
          placeholder="Votre message"
          [control]="groupForm.controls.comment"
        />
      </div>
    </section>

    <div formArrayName="participants" class="w-full max-w-[900px] space-y-8">
      @for (participant of participants.controls; track $index ;let i = $index)
      {
      <section [formGroupName]="$index" class="form-box">
        <div class="flex justify-center items-center relative mb-8">
          <h2 class="font-bebas text-4xl text-age-green uppercase text-center">
            PARTICIPANT {{ i + 1 }}
          </h2>
          @if (participants.length > 1) {
          <button
            (click)="removeParticipant(i)"
            class="absolute right-0 text-red-700 hover:opacity-70 cursor-pointer"
          >
            <lib-trash></lib-trash>
          </button>
          }
        </div>

        <section class="space-y-6 mb-4">
          <h3 class="text-lg font-bold text-age-green">Choix d’hébergement</h3>
          <div
            class="flex items-center justify-between gap-4 rounded-xl px-5 py-4 cursor-pointer border-[2px]"
            [ngClass]="{
                'bg-age-green text-white border-age-green':
                  getParticipantControl('pack', i).value === withoutAccomodation.id,
                'bg-age-price-bg text-age-green border-age-price-b':
                  getParticipantControl('pack', i).value !== withoutAccomodation.id
              }"
            (click)="selectRoom(i, withoutAccomodation.id)"
          >
            <div class="flex items-center gap-3">
              <span
                class="w-5 h-5 rounded-full bg-white text-age-green flex items-center justify-center text-sm font-bold"
                [ngClass]="{
                  'bg-white text-age-green':
                    getParticipantControl('pack', i).value === withoutAccomodation.id,
                  'border border-age-gold !bg-white':
                    getParticipantControl('pack', i).value !== withoutAccomodation.id
                }"
              >
                @if (getParticipantControl('pack', i).value ===
                withoutAccomodation.id) { ✓ }
              </span>

              <p class="font-bold">{{ withoutAccomodation.label }}</p>
            </div>
            <div class="flex items-center gap-4">
              <span class="font-bold"
                >{{ withoutAccomodation.price + ' DH' }}</span
              >
              <span
                class="text-xs font-bold bg-age-gold text-white px-3 py-1 rounded-full"
              >
                {{ withoutAccomodation.pack }}
              </span>
            </div>
          </div>

          <div class="grid grid-cols-2 md:grid-cols-4 gap-6">
            @for (pack of otherPacks; track pack.id) {
            <div
              (click)="selectRoom(i, pack.id)"
              class="relative cursor-pointer rounded-2xl p-4 flex flex-col gap-2 transition-all border-[2px]"
              [ngClass]="{
                'bg-age-green text-white border-age-green':
                  getParticipantControl('pack', i).value === pack.id,
                'bg-age-price-bg text-age-green border-age-price-b':
                  getParticipantControl('pack', i).value !== pack.id
              }"
            >
              <div
                class="absolute top-3 left-3 w-5 h-5 rounded-full flex items-center justify-center"
                [ngClass]="{
                  'bg-white text-age-green':
                    getParticipantControl('pack', i).value === pack.id,
                  'border border-age-gold !bg-white':
                    getParticipantControl('pack', i).value !== pack.id,
                }"
              >
                @if (getParticipantControl('pack', i).value === pack.id) { ✓ }
              </div>
              <span
                class="self-end text-xs font-bold px-3 py-1 rounded-full"
                [ngClass]="{
                  'bg-white/20 text-white':
                  getParticipantControl('pack', i).value === pack.id,
                  'bg-age-gold text-white':
                  getParticipantControl('pack', i).value !== pack.id,
                }"
              >
                {{ pack.pack }}
              </span>
              <div class="mt-4 text-center">
                <p class="text-[24px] font-bold">{{ pack.label }}</p>
                <p class="text-sm opacity-80">{{ pack.nights }} nuitées</p>
              </div>

              <p class="mt-2 text-center font-bold text-lg">
                {{ pack.price | number : '' : 'fr-FR' }} DH
              </p>
            </div>
            }
          </div>
          @if(isTwinEligible(i)){
          <div class="border-[2px] border-age-price-b rounded-xl bg-white p-4">
            <div class="flex gap-4 mb-2">
              <div
                class="w-10 h-10 flex items-center justify-center rounded-full bg-age-gold text-white text-lg"
              >
                <lib-lamp />
              </div>

              <div class="text-sm text-age-green">
                <p class="font-bold text-xl">Supplément Twin</p>
                <p class="opacity-80 text-age-brown">
                  Économisez en partageant votre chambre.
                </p>
                <p class="opacity-80 text-age-brown">
                  Sélectionnez cette option pour transformer deux réservations
                  Single en une chambre Twin.
                </p>
              </div>
            </div>

            <div
              class="flex items-center justify-between gap-4 rounded-xl px-5 py-4 cursor-pointer border-[2px]"
              [ngClass]="{
                'bg-age-green text-white border-age-green':
                  getParticipantControl('pack', i).value === packTwin.id,
                'bg-age-price-bg text-age-green border-age-price-b':
                  getParticipantControl('pack', i).value !== packTwin.id
              }"
              (click)="selectRoom(i, packTwin.id)"
            >
              <div class="flex items-center gap-3">
                <span
                  class="w-5 h-5 rounded-full bg-white text-age-green flex items-center justify-center text-sm font-bold"
                  [ngClass]="{
                  'bg-white text-age-green':
                    getParticipantControl('pack', i).value === packTwin.id,
                  'border border-age-gold !bg-white':
                    getParticipantControl('pack', i).value !== packTwin.id,
                }"
                >
                  @if (getParticipantControl('pack', i).value === packTwin.id) {
                  ✓ }
                </span>

                <div>
                  <p class="font-bold">{{ packTwin.pack }}</p>
                  <p class="text-sm opacity-80">{{ packTwin.label }}</p>
                </div>
              </div>
              <span class="font-bold">{{ packTwin.price + ' DH'}}</span>
            </div>
            @if(getParticipantControl('pack', i).value === 'PACK_SUPP'){
            <div class="space-y-2 mt-4">
              <lib-form-select
                label="Colocataire"
                [options]="participantsSelect(i)"
                [control]="getParticipantControl('roommate', $index)"
              />
            </div>
            }
          </div>
          }
        </section>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <lib-form-field
            label="Nom"
            placeholder="Votre nom"
            [control]="getParticipantControl('familyName', $index)"
          >
          </lib-form-field>
          <lib-form-field
            label="Prénom"
            placeholder="Votre prénon"
            [control]="getParticipantControl('firstName', $index)"
          >
          </lib-form-field>
          <lib-form-select
            label="Profession"
            [options]="professions"
            [control]="getParticipantControl('profession', $index)"
          ></lib-form-select>
          <lib-form-field
            label="Spécialité"
            placeholder="Votre spécialité"
            [control]="getParticipantControl('speciality', $index)"
          >
          </lib-form-field>
          <lib-form-field
            label="Numéro de téléphone"
            placeholder="+212 6 XX XX XX XX"
            type="tel"
            [control]="getParticipantControl('phoneNumber', $index)"
          />
          <lib-form-field
            label="Adresse email"
            placeholder="votre.email@exemple.com"
            type="email"
            [control]="getParticipantControl('email', $index)"
          />
          <lib-form-field
            label="Ville"
            placeholder="Votre ville"
            [control]="getParticipantControl('city', $index)"
          />
          <lib-form-field
            label="Pays"
            placeholder="Votre pays"
            [control]="getParticipantControl('country', $index)"
          />
        </div>
      </section>
      }
    </div>

    <button
      type="button"
      (click)="addParticipant()"
      class="w-full max-w-3xl border-2 border-dashed border-age-price-b bg-white rounded-xl py-4 flex items-center justify-center gap-2 text-age-green font-bold hover:bg-gray-50 transition-all cursor-pointer max-w-[900px]"
    >
      + Ajouter un participant
    </button>
    <div
      class="w-full max-w-3xl bg-age-green text-white py-8 px-10 rounded-[2rem] shadow-xl flex flex-col md:flex-row justify-between items-center gap-6 mt-4 mb-12 max-w-[900px]"
    >
      <div class="flex flex-col items-center md:items-start">
        <span class="text-[10px] uppercase font-bold opacity-70 tracking-widest"
          >TOTAL À PAYER</span
        >
        <span class="font-bebas text-5xl leading-none mt-1"
          >{{ totalAmount | number : '' : 'fr-FR' }} DH</span
        >
        <span class="text-[11px] opacity-60 font-semibold mt-1">
          {{ participants.length }} {{ participants.length > 1 ? 'paticipants':
          'participant'}}
        </span>
      </div>

      <div class="flex gap-4 w-full md:w-auto">
        <button
          type="button"
          routerLink="/"
          class="flex-1 md:flex-none bg-white text-age-green px-10 py-3 rounded-xl font-bold hover:bg-gray-100 transition-colors cursor-pointer text-sm"
        >
          Annuler
        </button>

        <button
          type="submit"
          [disabled]="isSubmitting()"
          class="flex-1 md:flex-none bg-age-gold text-age-green px-10 py-3 rounded-xl font-bold hover:opacity-90 transition-opacity cursor-pointer text-sm shadow-sm disabled:opacity-50 disabled:cursor-default"
        >
          @if (!isSubmitting()) { Valider l'inscription }@else {
          <span class="rounded-full animate-spin"></span>
          <span>Traitement...</span>
          }
        </button>
      </div>
    </div>
  </form>
</div>
<lib-footer></lib-footer>
